"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FleetViewAPI = function () {
  function FleetViewAPI($http, $window, config) {
    (0, _classCallCheck3.default)(this, FleetViewAPI);

    this.$http = $http;
    this.$window = $window;
    this.config = config;
  }

  (0, _createClass3.default)(FleetViewAPI, [{
    key: "get",
    value: function get(url, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.get("" + this.config.apiUrl + url, options);
    }
  }, {
    key: "post",
    value: function post(url, data, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.post("" + this.config.apiUrl + url, data, options);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var userString = this.$window.sessionStorage["userAuthInfo"];
      var user = JSON.parse(userString);

      var options = {
        headers: {
          "ALK-Language": undefined,
          "Authorization": "Bearer " + user.authToken
        }
      };

      return options;
    }
  }, {
    key: "getPagingQuery",
    value: function getPagingQuery(paging) {
      if (!paging) return [];

      var p = [];
      if (paging.pageNumber != null) p.push("pageNumber=" + paging.pageNumber);
      if (paging.limit != null) p.push("limit=" + paging.limit);
      if (paging.sortBy != null) p.push("sortBy=" + paging.sortBy);
      if (paging.sortAscending != null) p.push("sortAscending=" + paging.sortAscending);

      return p;
    }
  }, {
    key: "getArrayQuery",
    value: function getArrayQuery(key, arr) {
      if (arr == null) return [];

      var p = [];

      if (this.isArray(arr)) {
        for (var i = 0; i < arr.length; i++) {
          p.push(key + "=" + arr[i]);
        }
      } else {
        // if passed in item is not an array, but instead a single item
        p.push(key + "=" + arr);
      }

      return p;
    }
  }, {
    key: "isArray",
    value: function isArray(arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    }
  }]);
  return FleetViewAPI;
}();

exports.default = FleetViewAPI;


FleetViewAPI.$inject = ["$http", "$window", "alk.fleetview.config"];


// WEBPACK FOOTER //
// ./app/alk-fleetview/fleetview.api.js